<template>
    <div class="section message">
        <div class="container">
            <div class="message-text">
                {{$route.params.message}}
            </div>
            <div class="btn-container">
                <Button
                        class="btn btn-success button"
                        type="button"
                        @click="onClickButton"
                >
                    На главную
                </Button>
            </div>
        </div>
    </div>

</template>

<script>
    import {homePath} from "@/router/home"
    import {LoginModalProperties} from "@/utils/modalsProperties"
    import LoginModal from "@/components/homePage/LoginModal"
    import Button from "@/components/homePage/Button"

    export default {
        name: "ConfirmMessageTab",
        components: {Button},
        methods: {
            async onClickButton() {
                await this.$router.push(homePath)
                this.$modal.show(
                    LoginModal,
                    null,
                    LoginModalProperties
                )
            },
        }
    }
</script>

<style scoped lang="less">
    @import '../assets/less/variables.less';

    .section {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }

    .container {
        display: flex;
        flex-direction: column;
        gap: 28px;
        border-radius: 10px;
        background-color: #484E55;
        padding: 52px 130px;
        min-width: 316px;
        max-width: 560px;
        width: 560px;
        min-height: 100px;
        max-height: 300px;
        box-shadow:
            0 0 0 1px rgba(255, 255, 255, 0.08),
            0 12px 40px rgba(0, 0, 0, 0.35);
        @media (max-width: 1399px) {
            width: 406px;
            padding: 28px 53px;
        }
        @media (max-width: 767px) {
            width: 316px;
            padding: 28px 38px;
        }
    }
    .message {
        text-align: center;
    }
    .message-text {
        color: white;
        font-family: Montserrat;
        font-weight: 500;
        font-size: 14px;
        line-height: 1.5;
        text-align: center;
    }

    .btn-container {
        .button {
            max-width: 300px;
            width: 100%;
            height: 60px;
            background-color: #A5D8FF;
        }
    }

</style>